import React, {useEffect, useRef, useState} from "react";
import { connect } from "react-redux";
import {FormattedMessage} from "react-intl";

import ClickAwayListener from '@mui/material/ClickAwayListener';
import Grow from '@mui/material/Grow';
import Paper from '@mui/material/Paper';
import Popper from '@mui/material/Popper';
import MenuItem from '@mui/material/MenuItem';
import MenuList from '@mui/material/MenuList';
import ListItemIcon from '@mui/material/ListItemIcon';
import ShareIcon from '@mui/icons-material/Share';
import UndoIcon from '@mui/icons-material/Undo';
// import HelpIcon from '@mui/icons-material/Help';

import {setLookIntroStep, setLookOverlayOpened, setSidebarModalOpened} from "../../../../../actions/lookFunctions";
import COLOR_THEMES from "../../../../../colorThemes";
import {LOOK_INTRO_STEPS, LOOK_OVERLAYS} from "../../../core/constants";
import LookSideBarShareModal from "./lookSideBarShareModal";
import Analytics, {LOOK_JOURNEY_ANALYTIC_EVENTS} from "../../../../../analytics";

const LookSideBarModal = (props) => {

  const {sidebarModalOpened, setSidebarModalOpened, anchorEl, activeTheme, windowHeight, setLookOverlayOpened, isMobile,
    introStep, setLookIntroStep} = props;
  const anchorRef = useRef(null);
  const [shareModalOpened, setShareModalOpened] = useState(false);

  useEffect(() => {
    if (!sidebarModalOpened && shareModalOpened) {
      setShareModalOpened(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sidebarModalOpened])

  const handleClose = (event) => {
    if (event && anchorEl.current && anchorEl.current.contains(event.target)) {
      return;
    }
    if (shareModalOpened) {
      setShareModalOpened(false);
    }
    setSidebarModalOpened(false);
  };

  const shareClick = () => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarShare);
    if (introStep === LOOK_INTRO_STEPS.saveAndMore) {
      setLookIntroStep(introStep + 1);
      return false;
    }
    setShareModalOpened(!shareModalOpened);
  }

  const resetLookClick = (event) => {
    Analytics.sendClickEvent(LOOK_JOURNEY_ANALYTIC_EVENTS.lookSidebarReset);
    if (introStep === LOOK_INTRO_STEPS.saveAndMore) {
      setLookIntroStep(introStep + 1);
      return false;
    }
    handleClose(event);
    setLookOverlayOpened(LOOK_OVERLAYS.reset);
  }

  // const helpClick = (event) => {
  //   handleClose(event)
  // }

  return (
    <Popper open={sidebarModalOpened || (!isMobile && (introStep === LOOK_INTRO_STEPS.saveAndMore))}
            className="look-sidebar__modal"
            id={"sidebar-modal"}
            anchorEl={anchorEl.current}
            placement={windowHeight < 420 ? "right-end" : "right-start"}
            transition
            disablePortal={isMobile}>
      {({ TransitionProps }) => (
        <Grow
          {...TransitionProps}
          style={{ transformOrigin: "left center" }}
        >
          <Paper ref={anchorRef}>
            <ClickAwayListener onClickAway={handleClose}>
              <MenuList autoFocusItem={sidebarModalOpened} id="menu-list-grow">
                <MenuItem className="look-sidebar__modal-item" onClick={shareClick}>
                  <ListItemIcon>
                    <ShareIcon style={{ color: COLOR_THEMES[activeTheme].primary }} />
                  </ListItemIcon>
                  <FormattedMessage id="sidebarModal.share"/>
                </MenuItem>
                <MenuItem className="look-sidebar__modal-item" onClick={resetLookClick}>
                  <ListItemIcon>
                    <UndoIcon style={{ color: COLOR_THEMES[activeTheme].primary }} />
                  </ListItemIcon>
                  <FormattedMessage id="sidebarModal.resetLook"/>
                </MenuItem>
                {/*<MenuItem className="look-sidebar__modal-item" onClick={helpClick} disabled={true}>*/}
                {/*  <ListItemIcon>*/}
                {/*    <HelpIcon style={{ color: COLOR_THEMES[activeTheme].primary }} />*/}
                {/*  </ListItemIcon>*/}
                {/*  <FormattedMessage id="sidebarModal.help"/>*/}
                {/*</MenuItem>*/}
              </MenuList>
            </ClickAwayListener>
            <LookSideBarShareModal anchorEl={anchorRef}
                                   shareModalOpened={shareModalOpened}
                                   handleClose={handleClose}/>
          </Paper>
        </Grow>
      )}
    </Popper>
  )
};

const mapStateToProps = (store) => {
  const {windowHeight, activeTheme, isMobile} = store.serverState;
  const {sidebarModalOpened, introStep} = store.lookState;
  return {
    sidebarModalOpened,
    introStep,
    activeTheme,
    windowHeight,
    isMobile,
  };
};

const mapDispatchToProps = {
  setSidebarModalOpened,
  setLookOverlayOpened,
  setLookIntroStep,
};

export default connect(mapStateToProps, mapDispatchToProps)(LookSideBarModal)
